import { useCallback } from 'react';
import type { MumulLiveProfileStatus } from 'shared/src/api';
import { useLogMarketAnalyticsEvent } from '../../../hooks/useLogMarketAnalyticsEvent';

type CheckExp1867TargetLogParams = {
  marketSno: number;
  /** 무물라이브 프로필이 없으면 null */
  profileStatus: MumulLiveProfileStatus | null;
  hasPost: boolean;
};

/**
 * 무물라이브 실험(EXP1867) 대상 트래킹.
 * 마켓 프로필 영역 노출 시 A/B 양쪽 모두 1회 발화한다.
 */
export const useLogCheckExp1867Target = () => {
  const logMarketAnalytics = useLogMarketAnalyticsEvent();

  return useCallback(
    ({ marketSno, profileStatus, hasPost }: CheckExp1867TargetLogParams) => {
      logMarketAnalytics({
        name: 'CHECK_EXP_1867_TARGET',
        analytics: {
          PROFILE_STATUS: profileStatus,
          HAS_POST: hasPost ? 1 : 0,
          MARKET_SNO: marketSno.toString(),
        },
      });
    },
    [logMarketAnalytics],
  );
};
